import { render, staticRenderFns } from "./metier-edit.vue?vue&type=template&id=72349f20&"
import script from "./metier-edit.vue?vue&type=script&lang=js&"
export * from "./metier-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports